import { GInput, GTooltip } from 'components/basic-blocks'
import { ChangeEvent } from 'react'

import { RuleSummary } from '../../../rule-summary'
import { setSimpleValueAction } from '../../reducer'

import { RuleInfoProps } from './types'
import { HelpCircle as AiOutlineQuestionCircle } from 'components/icons'
export const RuleInfo = ({
	rule,
	targetName,
	level,
	platform,
	dispatch,
	errors,
	clearError
}: RuleInfoProps) => {
	return (
		<section className="flex flex-col gap-4">
			<div className="flex items-start gap-1 flex-col">
				<span className="text-t-base-blue font-medium">
					Rule name
				</span>
				<div className="w-full">
					<GInput
						name="name"
						placeholder="My custom rule"
						value={rule.name}
						onChange={(e: ChangeEvent<HTMLInputElement>) => {
							dispatch(setSimpleValueAction('name', e.target.value))
							clearError('name')
						}}
						inputClassName='border placeholder:text-t-gray-hold h-10 focus:ring-0 !font-[300] border-t-gray-input rounded-lg'
						errorPosition="absolute"
						errorClassName="mt-1"
						error={errors?.name}
					/>
				</div>
			</div>
			<div className="flex items-start gap-1 flex-col">
				<span className="text-t-base-blue font-medium">
					Description
				</span>
				<div className="w-full">
					<GInput
						placeholder="No description"
						value={rule.description}
						onChange={(e: ChangeEvent<HTMLInputElement>) =>
							dispatch(setSimpleValueAction('description', e.target.value))
						}
						inputClassName='border placeholder:text-t-gray-hold h-10 focus:ring-0 !font-[300] border-t-gray-input rounded-lg'
					/>
				</div>
			</div>

			<div>
				<div className="flex mb-2 items-center gap-2">
					<span className="text-t-base-blue text-xl font-medium">Summary</span>
					<GTooltip content="Verbal summarization of how will your rule work">
						<AiOutlineQuestionCircle className=" w-4 h-4 text-t-gray-hold" />
					</GTooltip>
				</div>

				<RuleSummary
					rule={rule}
					targetName={targetName}
					level={level}
					platform={platform}
					direction='flex-row flex'
					dirContainer='grid grid-cols-2 gap-4'
					titleClass='!text-t-base-blue'
				/>
			</div>
		</section>
	)
}
